import React, { useEffect, useRef, useState, } from 'react';
import { Dimensions, FlatList, Image as Img, Modal, Pressable, ScrollView, StyleSheet, Text, TextInput, TouchableOpacity, View, } from 'react-native';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, } from '@voltmoney/schema';
import { Icon } from '../icon/Icon';
import { ListBase } from '../list/List.base';
import { HeaderDefaultBase } from '../header/HeaderDefault.Base';
import { addCommasToNumber, isMobile } from '../stack/utils';
import { Typography } from '../typography/Typography';
import AsyncStorage from '@react-native-async-storage/async-storage';
let elssExist = false;
let equityExist = false;
let debtExist = false;
let selectedArray = [];
let selectedMap = {};
let combindedData = [];
let filters = [];
let nonEligibleFilters = [];
let totalEligibleValue = 0;
let totalNonValue = 0;
const eligibleData = [
    {
        isin: 'INF179K01YV8',
        nav: 853.432,
        ltv: 0.45,
        totalValue: 64000,
        eligibleValue: 64000,
        nonEligibleValue: 0,
        creditLimit: 28800,
        schemeName: 'HDFC Top 100 Fund',
        schemeCode: '44T',
        ownershipType: null,
        folioNumber: '21044673',
        amcCode: 'H',
        amcName: 'HDFC Mutual Fund',
        rtaCode: 'CAMS',
        panType: null,
        email: 'luniyaarpit240199@gmail.com',
        mobile: null,
        freeUnits: 75.03,
        blockedUnits: 0,
        blockedSubReason: null,
        blockedReason: null,
    },
    {
        isin: 'INF760K01EL8',
        nav: 134.24,
        ltv: 0.45,
        totalValue: 39200,
        eligibleValue: 39200,
        nonEligibleValue: 0,
        creditLimit: 17600,
        schemeName: 'Canara Robeco Equity Tax Saver ',
        schemeCode: 'ETDGG',
        ownershipType: null,
        folioNumber: '19922546862',
        amcCode: '101',
        amcName: 'Canara Robeco Mutual Fund',
        rtaCode: 'KARVY',
        panType: null,
        email: 'luniyaarpit240199@gmail.com',
        mobile: null,
        freeUnits: 292.52,
        blockedUnits: 0,
        blockedSubReason: null,
        blockedReason: null,
    },
];
// const mData = {
// 	overallSummary: {
// 		nonEligibleFundsSummary: {
// 			LOCKED: {
// 				KARVY: 77900,
// 			},
// 		},
// 		eligibleFundsSummary: {
// 			KARVY: 39300,
// 			CAMS: 64100,
// 		},
// 		totalFundsSummary: {
// 			KARVY: 117200,
// 			CAMS: 64100,
// 		},
// 		eligibleCreditLimit: {
// 			KARVY: 17700,
// 			CAMS: 0,
// 		},
// 	},
// 	eligibleAssetData: {
// 		MUTUAL_FUND: [
// 			{
// 				isin: 'INF179K01YV8',
// 				nav: 854.609,
// 				ltv: 0,
// 				totalValue: 64100,
// 				eligibleValue: 64100,
// 				nonEligibleValue: 0,
// 				creditLimit: 0,
// 				schemeName:
// 					'HDFC Top 100 Fund - Direct Plan - Growth Option (formerly HDFC Top 200 Fund)',
// 				schemeCode: '44T',
// 				ownershipType: null,
// 				folioNumber: '21044673',
// 				amcCode: 'H',
// 				amcName: 'HDFC Mutual Fund',
// 				rtaCode: 'CAMS',
// 				panType: null,
// 				email: 'luniyaarpit240199@gmail.com',
// 				mobile: null,
// 				fundType: 'EQUITY',
// 				freeUnits: 75.03,
// 				blockedUnits: 0,
// 				blockedSubReason: null,
// 				blockedReason: null,
// 			},
// 			{
// 				isin: 'INF760K01EL8',
// 				nav: 134.5,
// 				ltv: 0.45,
// 				totalValue: 39300,
// 				eligibleValue: 39300,
// 				nonEligibleValue: 0,
// 				creditLimit: 17700,
// 				schemeName:
// 					'Canara Robeco Equity Tax Saver Fund - Direct Growth',
// 				schemeCode: 'ETDGG',
// 				ownershipType: null,
// 				folioNumber: '19922546862',
// 				amcCode: '101',
// 				amcName: 'Canara Robeco Mutual Fund',
// 				rtaCode: 'KARVY',
// 				panType: null,
// 				email: 'luniyaarpit240199@gmail.com',
// 				mobile: null,
// 				fundType: 'EQUITY',
// 				freeUnits: 292.52,
// 				blockedUnits: 0,
// 				blockedSubReason: null,
// 				blockedReason: null,
// 			},
// 		],
// 	},
// 	nonEligibleAssetData: {
// 		MUTUAL_FUND: [
// 			{
// 				isin: 'INF769K01DM9',
// 				nav: 36.814,
// 				ltv: 0.45,
// 				totalValue: 77900,
// 				eligibleValue: 0,
// 				nonEligibleValue: 77900,
// 				creditLimit: 0,
// 				schemeName:
// 					'Mirae Asset Tax Saver Fund - Direct Growth',
// 				schemeCode: 'TSD1G',
// 				ownershipType: null,
// 				folioNumber: '79933763606',
// 				amcCode: '117',
// 				amcName: 'Mirae Asset Mutual Fund',
// 				rtaCode: 'KARVY',
// 				panType: null,
// 				email: 'luniyaarpit240199@gmail.com',
// 				mobile: null,
// 				fundType: 'ELSS',
// 				freeUnits: 0,
// 				blockedUnits: 2117.64,
// 				blockedSubReason: 'ELSS_LOCKED',
// 				blockedReason: 'LOCKED',
// 			},
// 		],
// 	},
// 	assetTypeToSummaryMap: {
// 		MUTUAL_FUND: {
// 			nonEligibleFundsSummary: {
// 				LOCKED: {
// 					KARVY: 77900,
// 				},
// 			},
// 			eligibleFundsSummary: {
// 				KARVY: 39300,
// 				CAMS: 64100,
// 			},
// 			totalFundsSummary: {
// 				KARVY: 117200,
// 				CAMS: 64100,
// 			},
// 			eligibleCreditLimit: {
// 				KARVY: 17700,
// 				CAMS: 0,
// 			},
// 		},
// 	},
// };
let mData = {
    eligibleAssetData: undefined,
    nonEligibleAssetData: undefined,
};
const AssetSearch = ({ dataa, onFitlerSet, isFromEligible, onChangeText, learnWhyAction, triggerAction, height }) => {
    const [showBar, setShowBar] = useState(true);
    const [eligiblePressed, setEligiblePresed] = useState(true);
    const [showFilter, setShowFilter] = useState(false);
    const [flatlistData, setFlatListData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [selectedList, setSelectedList] = useState(selectedArray);
    const [refresh, setRefresh] = useState(true);
    const inputRef = useRef(null);
    const [filterName, setFilterName] = useState('EQUITY');
    const [allSelected, setAllSelected] = useState(false);
    useEffect(() => {
        AsyncStorage.getItem("leadData").then((item) => {
            mData = JSON.parse(item);
            AsyncStorage.getItem("isEligible").then((item) => {
                console.warn("ITEM CALCULATION", item == "true");
                setEligiblePresed(item == "true");
                isFromEligible = item == "true";
                setTimeout(function () {
                    setInitialData();
                }, 5);
            });
        });
        console.warn("M DATA DRECEIVED IS", mData);
        // console.warn("DATA RECEIVED IS", JSON.parse(data))
        console.warn("IS ELIGIBLE VALUE", isFromEligible);
    }, []);
    const setInitialData = () => {
        filters = [];
        nonEligibleFilters = [];
        totalEligibleValue =
            mData?.eligibleAssetData?.MUTUAL_FUND.length >
                0
                ? sumObjectValues(mData?.eligibleAssetData?.MUTUAL_FUND)
                : 0;
        totalNonValue =
            mData?.nonEligibleAssetData?.MUTUAL_FUND.length >
                0
                ? sumObjectNonValues(mData?.nonEligibleAssetData?.MUTUAL_FUND)
                : 0;
        mData?.nonEligibleAssetData?.MUTUAL_FUND
            .length > 0 &&
            mData.nonEligibleAssetData.MUTUAL_FUND.map((item) => {
                if (nonEligibleFilters.includes(item.blockedReason)) {
                    // Do nothing basically
                }
                else {
                    nonEligibleFilters.push(item.blockedReason);
                }
            });
        mData.eligibleAssetData.MUTUAL_FUND.map((item) => {
            if (filters.includes(item.fundType)) {
                // Do nothing basically
            }
            else {
                filters.push(item.fundType);
            }
        });
        console.warn('FILTER ARE', isFromEligible);
        // @ts-
        //
        // ignore
        if (mData.eligibleAssetData.MUTUAL_FUND.length > 0 && isFromEligible)
            setFlatListData(
            // @ts-ignore
            mData.eligibleAssetData.MUTUAL_FUND);
        else {
            setEligiblePresed(false);
            setFlatListData(
            // @ts-ignore
            mData.nonEligibleAssetData.MUTUAL_FUND);
        }
        // @ts-ignore
        combindedData = [
            // @ts-ignore
            ...mData?.eligibleAssetData.MUTUAL_FUND,
            // @ts-ignore
            ...mData?.nonEligibleAssetData.MUTUAL_FUND,
        ];
        elssExist = combindedData.some((item) => item.fundType === 'ELSS');
        equityExist = combindedData.some((item) => item.fundType === 'EQUITY');
        debtExist = combindedData.some((item) => item.fundType === 'DEBT');
    };
    useEffect(() => {
        let selectedVal = true;
        filterData.map((item) => {
            if (selectedList.includes(item.isin)) {
                console.warn('VALUE REACHED HERE');
            }
            else {
                selectedVal = false;
            }
        });
        console.warn('VALUE REACHED HERE', selectedVal);
        if (selectedVal) {
            setAllSelected(true);
        }
        else {
            setAllSelected(false);
        }
    }, [filterData]);
    const sumObjectValues = (obj) => {
        // @ts-ignore
        let sumTotalValue = 0;
        for (let i = 0; i < obj.length; i++) {
            // @ts-ignore
            sumTotalValue += obj[i].totalValue;
        }
        return sumTotalValue;
    };
    const sumObjectNonValues = (obj) => {
        // @ts-ignore
        let sumTotalValue = 0;
        for (let i = 0; i < obj.length; i++) {
            // @ts-ignore
            sumTotalValue += obj[i].nonEligibleValue;
        }
        return sumTotalValue;
    };
    const handleLearnWhy = (item) => {
        console.log('item: ', item);
        if (learnWhyAction) {
            triggerAction && triggerAction({
                ...learnWhyAction,
                payload: {
                    ...learnWhyAction.payload,
                    item: item
                }
            });
        }
    };
    const renderItem = ({ item }) => {
        return (React.createElement(View, { style: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                paddingVertical: 8,
            } },
            React.createElement(View, null,
                React.createElement(View, { style: { width: Dimensions.get('window').width < 576 ? 200 : 300 } },
                    React.createElement(Typography, { label: item.schemeName, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, numberOfLines: 2, paddingBottom: 24, lineHeight: 24 })),
                React.createElement(Typography, { label: `Value: ₹${mData.eligibleAssetData.MUTUAL_FUND.includes(item)
                        ? addCommasToNumber(item.eligibleValue)
                        : addCommasToNumber(item.nonEligibleValue)}`, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20 }),
                !showBar && (React.createElement(View, { style: {
                        backgroundColor: mData.eligibleAssetData.MUTUAL_FUND.includes(item)
                            ? '#F3FAF6'
                            : '#F1F3F5',
                        borderColor: mData.eligibleAssetData.MUTUAL_FUND.includes(item)
                            ? '#CFEADA'
                            : '#E4E7EC',
                        borderWidth: 1,
                        borderRadius: 5,
                        paddingHorizontal: 4,
                        paddingVertical: 4,
                        justifyContent: 'center',
                        alignItems: 'center',
                        maxWidth: mData.eligibleAssetData.MUTUAL_FUND.includes(item)
                            ? 58
                            : 80,
                        marginTop: 9,
                    } },
                    React.createElement(Text, { style: {
                            fontFamily: 'Inter',
                            fontSize: 12,
                            color: mData.eligibleAssetData.MUTUAL_FUND.includes(item)
                                ? '#1D2939'
                                : '#667085',
                        } }, mData.eligibleAssetData.MUTUAL_FUND.includes(item)
                        ? 'Eligible'
                        : 'Non-eligible')))),
            React.createElement(View, { style: { alignItems: 'flex-end' } },
                React.createElement(Typography, { label: `₹${mData.nonEligibleAssetData.MUTUAL_FUND.includes(item) ? "0" : addCommasToNumber(item.creditLimit)}`, color: mData.nonEligibleAssetData.MUTUAL_FUND.includes(item) ? ColorTokens.Grey_Night : ColorTokens.Green_60, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.MD, numberOfLines: 2 }),
                mData?.nonEligibleAssetData?.MUTUAL_FUND.includes(item) && React.createElement(View, { style: { marginTop: 5 } },
                    React.createElement(Pressable, { onPress: () => handleLearnWhy(item) },
                        React.createElement(Typography, { label: "Learn why?", color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XXS, numberOfLines: 1 }))))));
    };
    const ChecklistItem = ({ item, onPress }) => {
        const [isChecked, setIsChecked] = useState(false);
        const handlePress = (item) => {
            console.warn('IN THIS ');
            setIsChecked(!isChecked);
            handleItemPress(item.isin);
        };
        return (React.createElement(View, { style: {
                paddingVertical: 16,
                paddingLeft: 10,
                paddingRight: 15,
                justifyContent: 'center',
            } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    alignContent: 'center',
                } },
                React.createElement(TouchableOpacity, { style: { paddingRight: 2, paddingLeft: 2 }, onPress: () => {
                        let data = selectedList;
                        console.warn('SEL data prior ', data);
                        const index = data.indexOf(item.isin);
                        if (index > -1) {
                            data.splice(index, 1);
                        }
                        else {
                            data.push(item.isin);
                        }
                        console.warn('SEL data ', data);
                        setSelectedList(data);
                        if (eligiblePressed) {
                            setFilterData(mData?.eligibleAssetData?.MUTUAL_FUND.filter((item) => item.fundType === filterName));
                        }
                        else {
                            setFilterData(mData?.nonEligibleAssetData?.MUTUAL_FUND.filter((item) => item.blockedReason === filterName));
                        }
                        // switch (filterName) {
                        // 	case 'EQUITY': {
                        // 		setFilterData(
                        // 			combindedData.filter(
                        // 				(item) => item.fundType === 'EQUITY',
                        // 			),
                        // 		);
                        // 		return;
                        // 	}
                        // 	case 'DEBT': {
                        // 		setFilterData(
                        // 			combindedData.filter(
                        // 				(item) => item.fundType === 'DEBT',
                        // 			),
                        // 		);
                        // 		return;
                        // 	}
                        // 	case 'ELSS': {
                        // 		setFilterData(
                        // 			combindedData.filter(
                        // 				(item) => item.fundType === 'ELSS',
                        // 			),
                        // 		);
                        // 		return;
                        // 	}
                        //}
                        // setFilterData(filterData);
                    } },
                    React.createElement(Icon, { name: selectedList.includes(item.isin)
                            ? IconTokens.CheckedSquare
                            : IconTokens.NotCheckedSquare, size: IconSizeTokens.XXL })),
                React.createElement(TouchableOpacity, { style: styles.itemContainer, onPress: () => {
                        handlePress(item);
                    } },
                    React.createElement(Text, { style: {
                            fontFamily: 'Inter',
                            fontSize: 16,
                            color: '#1D2939',
                        } }, item.schemeName)))));
    };
    const handleItemPress = (itemId) => {
        const updatedItems = filterData.map((item) => item.isin === itemId
            ? { ...item, checked: !item.checked }
            : item);
        console.warn('UPDATED ITEMS', updatedItems);
        setFilterData(updatedItems);
    };
    const filterHeader = () => {
        return (React.createElement(View, null,
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignItems: 'center',
                    alignContent: 'center',
                    // paddingTop: 11,
                    // paddingBottom: 11,
                    height: 60
                } },
                React.createElement(TouchableOpacity, { style: { paddingLeft: 12 }, onPress: () => {
                        setAllSelected(!allSelected);
                        let selectedAllList = selectedList;
                        console.warn("ALL SELECTED VALUE", allSelected);
                        if (allSelected) {
                            const isinKeys = filterData.map((item) => item.isin);
                            const filteredsArray = selectedAllList.filter((value) => !isinKeys.includes(value));
                            setSelectedList(filteredsArray);
                            return;
                        }
                        filterData.map((item) => {
                            selectedAllList.push(item.isin);
                        });
                        setSelectedList(selectedAllList);
                        //
                        // setFilterData(
                        //     combindedData.filter(
                        //         (item) => item.fundType === filterName,
                        //     ),
                        // );
                    } },
                    React.createElement(Icon, { name: allSelected
                            ? IconTokens.CheckedSquare
                            : IconTokens.NotCheckedSquare, size: IconSizeTokens.XXL })),
                React.createElement(TouchableOpacity, { style: styles.itemContainer, onPress: () => {
                    } },
                    React.createElement(Text, { style: [styles.itemText, { width: 200 }], ellipsizeMode: 'tail', numberOfLines: 1 }, 'Select All'))),
            React.createElement(View, { style: {
                    backgroundColor: '#E4E7EC',
                    height: 1,
                } })));
    };
    const applyFilter = () => {
        let filteredData = [];
        if (selectedList.length === 0) {
            setFlatListData(eligiblePressed ? mData.eligibleAssetData.MUTUAL_FUND : mData.nonEligibleAssetData.MUTUAL_FUND);
            return;
        }
        console.warn('FINAL FILTERED LIST $$$$$$$$$$$$$$$$$$$', selectedList);
        if (eligiblePressed) {
            mData.eligibleAssetData.MUTUAL_FUND.map((item) => {
                selectedList.includes(item.isin)
                    ? filteredData.push(item)
                    : null;
            });
        }
        else {
            mData.nonEligibleAssetData.MUTUAL_FUND.map((item) => {
                selectedList.includes(item.isin)
                    ? filteredData.push(item)
                    : null;
            });
        }
        console.warn('FINAL FILTERED LIST I9S', filteredData);
        setFlatListData(filteredData);
    };
    const renderListBase = () => {
        return (React.createElement(ListBase, { data: filterData, selectedMap: selectedMap }));
    };
    const renderFilterItem = ({ item }) => {
        return React.createElement(View, null);
    };
    const returnFilter = () => {
        return (React.createElement(View, { style: height ?
                { width: '100%', height: height ? height : '100%' } :
                { width: '100%', flex: 1 } },
            React.createElement(HeaderDefaultBase, { title: 'Filters', isBackButton: true, onPress: () => {
                    onChangeText(false);
                    setShowFilter(false);
                } }),
            React.createElement(View, { style: height ? {
                    flexDirection: 'row',
                    width: '100%',
                    borderTopWidth: 1,
                    borderColor: '#E4E7EC',
                    height: height ? height - 56 : '100%'
                } : {
                    flexDirection: 'row',
                    width: '100%',
                    borderTopWidth: 1,
                    borderColor: '#E4E7EC',
                } },
                React.createElement(FlatList, { style: { width: 150,
                        backgroundColor: '#F9FAFB', }, ItemSeparatorComponent: () => (React.createElement(View, { style: {
                            backgroundColor: '#E4E7EC',
                            height: 1,
                        } })), data: eligiblePressed
                        ? filters
                        : nonEligibleFilters, renderItem: ({ item }) => (React.createElement(View, null,
                        React.createElement(TouchableOpacity, { style: {
                                justifyContent: 'center',
                                alignItems: 'flex-start',
                                padding: 20,
                            }, onPress: () => {
                                if (eligiblePressed) {
                                    setFilterData(mData.eligibleAssetData?.MUTUAL_FUND.filter((items) => items.fundType === item));
                                }
                                else {
                                    setFilterData(mData.nonEligibleAssetData?.MUTUAL_FUND.filter((items) => items.blockedReason === item));
                                }
                                setFilterName(item);
                            } }, React.createElement(Typography, { label: item, color: filterName === item
                                ? ColorTokens.Grey_Night
                                : ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter })))) }),
                React.createElement(View, { style: {
                        width: 1,
                        height: '100%',
                        backgroundColor: '#E4E7EC',
                    } }),
                React.createElement(ScrollView, { nestedScrollEnabled: true, style: height ? { height: height - 56, paddingBottom: 40 } : { height: 550 } },
                    filterHeader(),
                    filterData.map((item) => {
                        return (React.createElement(View, null,
                            React.createElement(ChecklistItem, { item: item, onPress: handleItemPress }),
                            React.createElement(View, { style: { backgroundColor: '#E4E7EC', height: 1 } })));
                    }))),
            React.createElement(View, { style: {
                    height: 56,
                    position: "absolute",
                    bottom: 0,
                    flexDirection: 'row',
                    backgroundColor: 'white',
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: Dimensions.get('window').width < 576
                        ? 'center'
                        : 'flex-end',
                    borderWidth: 1,
                    borderColor: '#ddd',
                    borderBottomWidth: 0,
                    shadowColor: '#000000',
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.9,
                    shadowRadius: 3,
                    elevation: 5,
                    // paddingBottom: 16,
                } },
                React.createElement(TouchableOpacity, { onPress: () => {
                        setAllSelected(false);
                        setSelectedList([]);
                    }, style: {
                        marginRight: 18,
                        borderWidth: 1,
                        borderColor: '#1434CB',
                        backgroundColor: 'white',
                        width: 131,
                        height: 32,
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 50,
                    } },
                    React.createElement(Typography, { label: 'Reset filter', color: ColorTokens.Primary_100 })),
                React.createElement(TouchableOpacity, { onPress: () => {
                        applyFilter();
                        onChangeText(false);
                        setShowFilter(false);
                    }, style: {
                        marginRight: 30,
                        backgroundColor: '#1434CB',
                        width: 131,
                        height: 32,
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 50,
                    } },
                    React.createElement(Typography, { label: 'Apply', color: ColorTokens.White })))));
    };
    return showFilter ? (returnFilter()) : (React.createElement(View, { style: {
            height: isMobile ? 350 : 450,
            width: '100%',
            paddingHorizontal: 15,
        } },
        React.createElement(View, null,
            React.createElement(TextInput, { style: styles.input, placeholder: 'Search funds', placeholderTextColor: "#98A2B3", ref: inputRef, onChangeText: (searchString) => {
                    console.warn('FINAL string', searchString);
                    if (searchString.length > 0) {
                        let filteredData = combindedData.filter(function (item) {
                            return item.schemeName
                                .toLowerCase()
                                .includes(searchString.toLowerCase());
                        });
                        setFlatListData(filteredData);
                        setShowBar(false);
                    }
                    else {
                        setShowBar(true);
                        if (mData.eligibleAssetData.MUTUAL_FUND.length > 0) {
                            setEligiblePresed(true);
                            setFlatListData(mData.eligibleAssetData.MUTUAL_FUND);
                        }
                        else {
                            setFlatListData(mData.nonEligibleAssetData.MUTUAL_FUND);
                        }
                    }
                }, underlineColorAndroid: 'transparent' }),
            React.createElement(TouchableOpacity, { style: {
                    position: 'absolute',
                    right: 0,
                    marginTop: 25,
                    marginRight: 20,
                }, onPress: () => {
                    if (!showBar) {
                        inputRef.current.clear();
                        setShowBar(true);
                        if (mData.eligibleAssetData.MUTUAL_FUND.length > 0) {
                            setEligiblePresed(true);
                            setFlatListData(mData.eligibleAssetData.MUTUAL_FUND);
                        }
                        else {
                            setFlatListData(mData.nonEligibleAssetData.MUTUAL_FUND);
                        }
                    }
                } },
                React.createElement(Icon, { name: showBar
                        ? IconTokens.Search
                        : IconTokens.Cross, size: showBar
                        ? IconSizeTokens.LG
                        : IconSizeTokens.XL, color: ColorTokens.Grey_Smoke }))),
        showBar &&
            mData?.eligibleAssetData?.MUTUAL_FUND
                ?.length !== 0 && mData?.nonEligibleAssetData?.MUTUAL_FUND
            ?.length !== 0 && (React.createElement(View, { style: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginTop: 30,
                marginBottom: 8
            } },
            React.createElement(TouchableOpacity, { style: {
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                    width: '50%',
                }, onPress: () => {
                    setEligiblePresed(true);
                    setFlatListData(
                    // @ts-ignore
                    mData.eligibleAssetData.MUTUAL_FUND);
                } },
                React.createElement(Text, { style: {
                        color: eligiblePressed
                            ? '#1434CB'
                            : '#667085',
                    } }, "Eligible funds"),
                React.createElement(Text, { style: {
                        color: eligiblePressed
                            ? '#1434CB'
                            : '#667085',
                    } },
                    ' ',
                    '₹' +
                        addCommasToNumber(totalEligibleValue)),
                React.createElement(View, { style: {
                        width: '100%',
                        height: 2,
                        backgroundColor: eligiblePressed
                            ? '#1434CB'
                            : '#E4E7EC',
                        marginTop: 6,
                    } })),
            React.createElement(TouchableOpacity, { style: {
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '50%',
                }, onPress: () => {
                    setEligiblePresed(false);
                    setFlatListData(
                    // @ts-ignore
                    mData.nonEligibleAssetData.MUTUAL_FUND);
                } },
                React.createElement(Text, { style: {
                        color: !eligiblePressed
                            ? '#1434CB'
                            : '#667085',
                    } }, "Non eligible funds"),
                React.createElement(Text, { style: {
                        color: !eligiblePressed
                            ? '#1434CB'
                            : '#667085',
                    } },
                    ' ',
                    '₹' + addCommasToNumber(totalNonValue)),
                React.createElement(View, { style: {
                        width: '100%',
                        height: 2,
                        backgroundColor: !eligiblePressed
                            ? '#1434CB'
                            : '#E4E7EC',
                        marginTop: 6,
                    } })))),
        React.createElement(View, { style: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginTop: 15,
            } },
            React.createElement(Typography, { label: flatlistData.length + ' MFs', color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.MD }),
            showBar && (React.createElement(View, { style: { flexDirection: 'row' }, nativeID: 'txt_assetSearch_applyFilter' },
                React.createElement(TouchableOpacity, { onPress: () => {
                        onChangeText(true);
                        console.warn('FILTERED DATA INITIAL ', eligiblePressed, filters[0]);
                        if (eligiblePressed) {
                            setFilterData(mData.eligibleAssetData.MUTUAL_FUND.filter((item) => item.fundType === filters[0]));
                            setFilterName(filters[0]);
                        }
                        else {
                            setFilterData(mData.nonEligibleAssetData.MUTUAL_FUND.filter((item) => item.blockedReason ===
                                nonEligibleFilters[0]));
                            setFilterName(nonEligibleFilters[0]);
                        }
                        setShowFilter(true);
                    } },
                    React.createElement(Typography, { label: 'Apply filter ', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night })),
                React.createElement(TouchableOpacity, { onPress: () => {
                        onChangeText(true);
                        console.warn('FILTERED DATA INITIAL ', eligiblePressed, filters[0]);
                        if (eligiblePressed) {
                            setFilterData(mData.eligibleAssetData.MUTUAL_FUND.filter((item) => item.fundType === filters[0]));
                            setFilterName(filters[0]);
                        }
                        else {
                            setFilterData(mData.nonEligibleAssetData.MUTUAL_FUND.filter((item) => item.blockedReason ===
                                nonEligibleFilters[0]));
                            setFilterName(nonEligibleFilters[0]);
                        }
                        setShowFilter(true);
                    } },
                    React.createElement(Img, { style: {
                            width: 20,
                            height: 20,
                            marginLeft: 5,
                        }, source: {
                            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/filter.png',
                        }, borderRadius: 8 }))))),
        React.createElement(View, { style: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginTop: 15,
            } },
            React.createElement(Typography, { label: 'Mutual funds', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Charcoal }),
            React.createElement(Typography, { label: 'Eligible limit', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Charcoal })),
        flatlistData.length > 0 ? (React.createElement(FlatList, { data: flatlistData, renderItem: renderItem, ItemSeparatorComponent: () => (React.createElement(View, { style: {
                    backgroundColor: '#E4E7EC',
                    height: 1,
                } })) })) : (React.createElement(View, { style: {
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 40,
            } },
            React.createElement(Img, { style: { width: 140, height: 140 }, source: {
                    uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/no_investment_1.png',
                }, borderRadius: 8 }),
            React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(Typography, { label: 'No results found' })))),
        React.createElement(Modal, { animationType: 'slide', transparent: true, visible: showFilter, style: { position: 'absolute', bottom: 0 } },
            React.createElement(View, { style: styles.modalContainer },
                React.createElement(TouchableOpacity, { onPress: () => {
                    } })))));
};
const styles = StyleSheet.create({
    input: {
        height: 48,
        width: '100%',
        borderColor: '#98A2B3',
        borderWidth: 1,
        borderRadius: 4,
        padding: 10,
        marginTop: 10,
        color: 'black',
    },
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    button: {
        width: 200,
        height: 50,
        backgroundColor: 'blue',
        borderRadius: 10,
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalContainer: {
        position: 'absolute',
        bottom: 0,
        width: 504,
        height: 600 * 0.5,
        backgroundColor: 'white',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        padding: 20,
        justifyContent: 'flex-end',
    },
    itemContainer: {
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 2,
        maxWidth: Dimensions.get('window').width < 576
            ? '85%'
            : '90%',
        marginLeft: 8,
    },
    itemText: {
        fontSize: 16,
        marginLeft: 3,
    },
    checkedItemText: {
        textDecorationLine: 'line-through',
    },
});
export default AssetSearch;
